<div class="flex-column add-gap fs-14">
  <div>
    <app-form-label [label]="translations.internalReferenceNumber"></app-form-label>
    @if (canNavigateToDetailsPage()) {
      <app-form-link [link]="link()" [styledLink]="true" [openInNewTab]="true">
        {{ ddsReference().internalReferenceNumber }}
      </app-form-link>
    } @else {
      <app-value-and-copy-button
        [value]="ddsReference().internalReferenceNumber"
      ></app-value-and-copy-button>
    }
  </div>
  @if (showExtendedDetails()) {
    <div>
      <app-form-label [label]="translations.status"></app-form-label>
      @if (this.hasDdsStatusUpdateFailed() === null) {
        <app-loader containerClass="size-small"></app-loader>
      } @else {
        <app-dds-status-tag
          [status]="ddsReference().status"
          [lastStatusUpdate]="ddsReference().lastStatusUpdate"
          [isDdsStatusUpdateFailed]="this.hasDdsStatusUpdateFailed()"
          [shouldShowAlertIcon]="!!ddsReference().ddsIdentifier"
        ></app-dds-status-tag>
      }
    </div>
    @if (!isPending() && !isSubmitted()) {
      <div>
        <app-form-label [label]="translations.tracesReferenceNumber"></app-form-label>
        {{ ddsReference().referenceNumber || "-" }}
      </div>
      <div>
        <app-form-label [label]="translations.tracesVerificationNumber"></app-form-label>
        <div class="flex add-gap">
          <div>
            @if (displayVerificationNumber()) {
              {{ ddsReference().verificationNumber || "-" }}
            } @else {
              ******
            }
          </div>
          <mat-icon
            class="clickable"
            [tp]="displayVerificationNumber() ? translations.hide : translations.show"
            (click)="toggleDisplayVerificationNumber()"
          >
            {{ visibilityIcon() }}
          </mat-icon>
        </div>
      </div>
    }
  }
</div>
